import { render } from "./EditProfileContainer.vue?vue&type=template&id=ea1bd33c"
import script from "./EditProfileContainer.vue?vue&type=script&lang=js"
export * from "./EditProfileContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__